import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import { all_videos } from 'data/YoutubeVideos'
import { useRouter } from 'next/router'
import { templates_data } from 'data/Templates'
import axios from 'axios'
import { getAuthKey, getThumbnailImage } from 'constant/functions'
import Onboarding_steps_bar from '../../../partials/Onboarding_steps_bar'
import User_store from '@/store/User_store'
import { MixpanelEventName, MixpanelPropertiesName, MixpanelTracking } from 'constant/mixpnael'
import ReactPaginate from 'react-paginate'
var slugify = require('slugify')

function TemplatesList({ categories, templates }) {
  const router = useRouter()
  const ct_id = router.query.category_id && router.query.category_id
  const [userDetails, setUserDetails] = useState(null)
  const [tenantDetails, setTenantDetails] = useState(null)

  const [pageCount, setPageCount] = useState(0)

  // Count and set total page

  useEffect(() => {
    const totalpage = Math.ceil(templates.total_records / 30)
    if (templates?.total_records && Number(templates?.total_records) > 30) {
      setPageCount(totalpage)
    } else {
      setPageCount(0)
    }
  }, [templates])

  //short details
  const short_details = (attributes) => {
    return attributes.filter((at) => at.name === 'Short Description')[0].values[0]
  }

  return (
    <section className="relative">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="  pb-12   ">
          {/* Page header */}

          <Onboarding_steps_bar />

          <div className="  pb-12   text-left  space-y-4">
            <h1 className="h1   ">Choose a template to kickstart your Idea </h1>

            <div className="bg-[#E8FFFA]  shadow max-w-full  px-5 py-2   flex-grow flex flex-col gap-8">
              <div className="  flex  flex-col md:flex-row items-center justify-center gap-3 flex-grow text-left">
                <h3 className=" text-base font-semibold  md:max-w-[220px] text-center md:text-left  ">
                  Custom Template Development
                </h3>
                <p className=" text-sm text-gray-600 text-center md:text-left    flex-grow  ">
                  If you are looking for a custom development with concierge service. Starts from
                  $350
                </p>
                <Link href="/support">
                  <a className=" flex-none w-auto btn_primary mx-auto ">Contact for a Quote</a>
                </Link>
              </div>
            </div>
          </div>

          {/* Section tags */}
          {categories !== null && (
            <div className="border-b border-gray-300 pb-4 mb-12">
              <ul className="flex flex-wrap justify-center md:justify-start font-medium -mx-5 -my-1">
                <li className="mx-5 my-1">
                  <Link href="/templates" passHref>
                    <a
                      className={
                        !ct_id && router.pathname === '/templates'
                          ? 'text-blue-600'
                          : 'text-gray-800 hover:underline"'
                      }
                    >
                      All
                    </a>
                  </Link>
                </li>
                {categories?.map((ct) => {
                  if (ct.id == 4045) {
                    return ct?.sub_category.map((ct_sub) => {
                      return (
                        <li className="mx-5 my-1">
                          <Link href={`/templates?category_id=${ct_sub.id}`} passHref>
                            <a
                              className={
                                router.query.category_id == ct_sub.id
                                  ? 'text-blue-600'
                                  : 'text-gray-800 hover:underline"'
                              }
                            >
                              {ct_sub.name}
                            </a>
                          </Link>
                        </li>
                      )
                    })
                  }
                })}
              </ul>
            </div>
          )}

          {/* Templates list */}
          {templates?.listings !== null && (
            <div className="max-w-sm mx-auto md:max-w-none">
              {/* Articles container */}
              <div className="grid gap-12 md:grid-cols-3 md:gap-x-6 md:gap-y-8 items-start">
                {templates?.listings?.map((item) => {
                  const categories_name = (id) => {
                    return categories
                      ?.filter((ct) => ct.id === 4045)[0]
                      ?.sub_category.filter((ct_sub) => ct_sub.id === id)[0]?.name
                  }
                  const Type = (attributes) => {
                    return attributes.filter((at) => at.name === 'Type')[0]?.values[0]?.name
                  }

                  // is_active
                  const is_active = (attributes) => {
                    return attributes.filter((at) => at.name === 'Active')[0]?.values[0] == true
                      ? true
                      : undefined
                  }

                  return (
                    <Link href={`/templates/${item.slug}`}>
                      <a>
                        <article
                          className="flex flex-col h-full sha rounded-md overflow-hidden  border border-[#eaeaea]   shadow-c-sm  hover:shadow-medium p-6"
                          data-aos="zoom-y-out"
                        >
                          <header>
                            <div className=" w-full h-[200px] block relative mb-6 overflow-hidden ">
                              <img
                                className="w-full h-full object-cover object-top "
                                src={item.images[0]}
                                alt=""
                              />
                            </div>

                            <div className="mb-3 px-2">
                              <ul className="flex flex-wrap text-xs font-medium -m-1">
                                {item.type && (
                                  <li className="m-1">
                                    <a className="inline-flex text-center text-gray-100 py-1 px-3 rounded-full bg-blue-500 hover:bg-blue-600 transition duration-150 ease-in-out">
                                      {Type(item.attributes)}
                                    </a>
                                  </li>
                                )}
                                {is_active(item.attributes) === undefined && (
                                  <li className="m-1">
                                    <a className="inline-flex text-center text-[#959393] bg-[#E2E2E2]  py-1 px-3 rounded-full transition duration-150 ease-in-out">
                                      Coming Soon
                                    </a>
                                  </li>
                                )}
                                {/* {item.type && (
                              <li className="m-1">
                                <a className="inline-flex text-center text-gray-800 py-1 px-3 rounded-full bg-blue-100 hover:bg-blue-200 transition duration-150 ease-in-out">
                                  {item.type}
                                </a>
                              </li>
                            )} */}
                              </ul>
                            </div>
                            <h3 className=" px-2 text-xl font-bold leading-snug tracking-tight mb-2">
                              {item.title}
                            </h3>
                          </header>
                          {item?.description && (
                            <p className="px-2 text-gray-600 flex-grow">
                              {short_details(item.attributes).length > 60
                                ? short_details(item.attributes).substring(0, 60) + '...'
                                : short_details(item.attributes)}
                            </p>
                          )}
                        </article>
                      </a>
                    </Link>
                  )
                })}
              </div>
            </div>
          )}

          <div className="mt-12   flex justify-center pb-12 ">
            {templates?.listings !== null && (
              <ReactPaginate
                breakLabel="..."
                nextLabel={
                  <svg
                    className="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                }
                onPageChange={(data) =>
                  router.push({
                    pathname: `/templates`,
                    query: { ...router.query, page: Number(data.selected) + 1 },
                  })
                }
                pageRangeDisplayed={2}
                pageCount={pageCount}
                previousLabel={
                  <svg
                    className="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                }
                renderOnZeroPageCount={null}
                containerClassName=""
                className="relative z-0 inline-flex flex-wrap justify-center rounded-button shadow-sm -space-x-px "
                pageClassName="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center text-sm font-medium"
                pageLinkClassName="px-4 py-2 border"
                previousClassName="relative inline-flex items-center px-2 py-2   border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                nextClassName="relative inline-flex items-center px-2 py-2   border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                breakLinkClassName="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700"
                activeLinkClassName="z-10 bg-primary  border-primary text-white relative inline-flex items-center px-4 py-2 border text-md font-semibold"
                disabledLinkClassName=""
                prevPageRel="2"
                forcePage={templates?.page - 1}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default TemplatesList
